import { AlertTriangle, FolderOpen, RefreshCw } from "lucide-react";

export function PageLoader({ label = "Loading your workspace" }: { label?: string }) {
  return (
    <output className="grid min-h-[360px] place-items-center">
      <div className="w-full max-w-3xl space-y-4 px-5">
        <span className="sr-only">{label}</span>
        <div className="skeleton h-7 w-52 rounded" />
        <div className="skeleton h-28 w-full rounded-xl" />
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="skeleton h-48 rounded-xl" />
          <div className="skeleton h-48 rounded-xl" />
        </div>
      </div>
    </output>
  );
}

export function ErrorState({ error, retry }: { error: Error; retry?: () => void }) {
  return (
    <div className="card mx-auto my-10 max-w-xl rounded-xl p-8 text-center" role="alert">
      <div className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-red-50 text-red-700">
        <AlertTriangle className="size-6" aria-hidden="true" />
      </div>
      <h2 className="text-lg font-extrabold">We couldn’t load this workspace</h2>
      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-neutral-600">{error.message}</p>
      {retry ? (
        <button className="btn-secondary mt-6" type="button" onClick={retry}>
          <RefreshCw className="size-4" aria-hidden="true" />
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  message,
  action,
}: {
  title: string;
  message: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="card rounded-xl px-6 py-12 text-center">
      <div className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-neutral-100 text-neutral-500">
        <FolderOpen className="size-6" aria-hidden="true" />
      </div>
      <h3 className="font-extrabold">{title}</h3>
      <p className="mx-auto mt-2 max-w-lg text-sm leading-6 text-neutral-600">{message}</p>
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
